export default "__VITE_ASSET__HXmzc$fh__"